import { render } from "./ORAs.vue?vue&type=template&id=3e53ac70&scoped=true"
import script from "./ORAs.vue?vue&type=script&lang=js"
export * from "./ORAs.vue?vue&type=script&lang=js"

import "./ORAs.vue?vue&type=style&index=0&id=3e53ac70&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e53ac70"]])

export default __exports__